import { render } from "./GameNavBar.vue?vue&type=template&id=a9d601e8"
import script from "./GameNavBar.vue?vue&type=script&lang=js"
export * from "./GameNavBar.vue?vue&type=script&lang=js"

import "./GameNavBar.vue?vue&type=style&index=0&id=a9d601e8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__